export default __webpack_public_path__ + "static/media/mixfiscal-plataforma.98794ead.svg";